import React from 'react';

export const DateTimeDisplay = ({
  date,
}: {
  date: string | Date | undefined;
}) => {
  if (!date) {
    return <span>N/A</span>;
  }
  const parsedDate = new Date(date);

  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  };
  const formatted = parsedDate.toLocaleString('en-NZ', options);

  return <span>{formatted}</span>;
};
